/**
 * Manage nav catalog. `path` is relative to router basename.
 * All admin modules are native in the public app at /manage.
 */
export const MANAGE_MODULES = [
  {
    key: 'dashboard',
    label: 'Dashboard',
    path: '/manage',
    exact: true,
    native: true,
  },
  {
    key: 'users',
    label: 'Users',
    path: '/manage/users',
    native: true,
  },
  {
    key: 'donations',
    label: 'Donation',
    path: '/manage/donations',
    native: true,
  },
  {
    key: 'donation_type',
    label: 'Donation Type',
    path: '/manage/donation-type',
    native: true,
  },
  {
    key: 'expense_types',
    label: 'Expense Type',
    path: '/manage/expense-types',
    native: true,
  },
  {
    key: 'expenses',
    label: 'Expense',
    path: '/manage/expenses',
    native: true,
  },
  {
    key: 'gallary',
    label: 'Gallery',
    path: '/manage/gallery',
    native: true,
  },
  {
    key: 'hero_banner',
    label: 'Hero banner',
    path: '/manage/hero-banner',
    native: true,
  },
  {
    key: 'pages',
    label: 'Website pages',
    path: '/manage/pages',
    native: true,
  },
  {
    key: 'menus',
    label: 'Menus',
    path: '/manage/menus',
    native: true,
  },
  {
    key: 'settings',
    label: 'Settings',
    path: '/manage/settings',
    native: true,
  },
  {
    key: 'user_roles',
    label: 'User Roles',
    path: '/manage/roles',
    native: true,
  },
  {
    key: 'user_reports',
    label: 'User reports',
    path: '/manage/user-reports',
    native: true,
  },
  {
    key: 'donation_reports',
    label: 'Donation report',
    path: '/manage/donation-reports',
    native: true,
  },
  {
    key: 'donation_type_reports',
    label: 'Donation type report',
    path: '/manage/donation-type-reports',
    native: true,
  },
]

/** Sidebar sections — order of keys controls link order within each section. */
export const MANAGE_NAV_SECTIONS = [
  {
    id: 'main',
    label: 'Main',
    keys: ['dashboard', 'donations', 'donation_type', 'expenses', 'expense_types'],
  },
  {
    id: 'website',
    label: 'Website',
    keys: ['hero_banner', 'gallary', 'pages', 'menus'],
  },
  {
    id: 'reports',
    label: 'Reports',
    keys: ['donation_reports', 'donation_type_reports', 'user_reports'],
  },
  {
    id: 'settings',
    label: 'Settings',
    keys: ['users', 'user_roles', 'settings'],
  },
]

export function moduleByKey(key) {
  return MANAGE_MODULES.find((m) => m.key === key)
}
